import styled from 'styled-components'
import { theme } from 'utils/theme'

export const InputSelectContainer = styled.div`
  .input-select__control {
    min-width: 200px;
    cursor: pointer;
  }

  .input-select__menu {
    .input-select__menu-list {
      color: ${theme.colors.background};
      > .input-select__option--is-focused {
        background: transparent;
      }
      > .input-select__option--is-selected {
        background: transparent;
        color: ${theme.colors.primaryRed};
      }
      .input-select__option {
        cursor: pointer !important;
      }
    }
  }
`

export const InputTextLabel = styled.label``

export const ErrorMsgContainer = styled.div``
